import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { I18N, CMap, GlobalContext, EB360MapComponent } from 'commons';
import { DEFAULT_MAP_CENTER } from 'constants/signUp';

const VerifyLocationModal = ({ isOpen, close, address }) => {
  const { lang, googleMapParam, idToken, organization: { isEB360MapEnabled = true } } = useContext(GlobalContext);
  const [Component, setComponent] = React.useState(null);

  const coordinates = address.position?{
    lat: Number(address.position.lat),
    lng: Number(address.position.lng)
  } : {
    lat: DEFAULT_MAP_CENTER.lat,
    lng: DEFAULT_MAP_CENTER.lng
  }

  const renderMap = () => {
    if (isEB360MapEnabled) {
      return <EB360MapComponent
        idToken={idToken}
        lang={lang}
        coordinates={coordinates}
        address={address.streetAddress}
      />;
    }
    return <CMap
      lang={lang}
      googleMapParam={googleMapParam}
      markers={[{ ...address, active: true }]}
      center={coordinates}
      comeFrom="viewOnMap"
    />;
  }

  return (
    <Modal
      isOpen={isOpen}
      modalClassName="view-map js_listen_map new"
    >
      <ModalHeader toggle={close}>
        <I18N>ssp.location.view.map</I18N>
      </ModalHeader>
      <ModalBody className="view-map-height">
        {renderMap()}

      </ModalBody>
      <ModalFooter className="view-map-footer">
        <Button color="primary" onClick={close}>
          <I18N>button.close</I18N>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

VerifyLocationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  address: PropTypes.shape().isRequired,
};
export default VerifyLocationModal;
